module.exports = __webpack_public_path__ + "img/jigsawPuzzle_4.21ba4812.png";